import {
  Card,
  Text,
  Badge,
  Space,
  Button,
  Group,
  Modal,
  ThemeIcon,
} from '@mantine/core';
import { HiPencil } from 'react-icons/hi2';
import { HiOutlinePlus } from 'react-icons/hi';
import { useClientIPPFormContext } from '../ClientIppSection';
import { WorkerModal } from '../Modals/WorkerModal';
import { useDisclosure } from '@mantine/hooks';
import { FaInfo } from 'react-icons/fa';
import { useState } from 'react';
import { TbTrashXFilled } from 'react-icons/tb';
import { isEmptyForm } from '@/utils/functions';

export const WorkersCard: React.FC = () => {
  const form = useClientIPPFormContext();

  const [modalOpened, { open, close }] = useDisclosure(false);
  const [selectedWorker, setSelectedWorker] = useState<number | null>(null);

  if (isEmptyForm(form)) {
    return <></>;
  }
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Text fw={700} size="lg">
        Klíčový pracovník
      </Text>
      <Space h="lg" />
      <Card shadow="none" withBorder>
        {form.values.keyEmp?.id === null || form.values.keyEmp === null ? (
          <Group justify="space-between">
            <Group>
              <ThemeIcon variant="white">
                <FaInfo style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <p>Není přidělen žádný pracovník</p>
            </Group>

            <Button
              variant="subtle"
              data-testid="plus-button"
              onClick={() => {
                setSelectedWorker(null);
                open();
              }}
            >
              <HiOutlinePlus color="black" size="1.9em" />
            </Button>
          </Group>
        ) : (
          <Group justify="space-between">
            <Text>{form.values.keyEmp.firstName}</Text>
            <Text>{form.values.keyEmp.lastName}</Text>
            {form.getInputProps('keyEmp.access.role').value === null ||
            form.getInputProps('keyEmp.access.role').value === '' ? (
              <></>
            ) : (
              <Badge color="blue" size="lg" radius="md">
                {form.values.keyEmp.access.role}
              </Badge>
            )}
            <Group>
              <Button
                ml="xl"
                variant="subtle"
                data-testid="pencil-button"
                onClick={() => {
                  setSelectedWorker(form.values.keyEmp?.id);
                  open();
                }}
              >
                <HiPencil color="black" size="1.7em" />
              </Button>
              <Button
                variant="subtle"
                data-testid="trash-button"
                onClick={() => {
                  form.setFieldValue('keyEmp.id', null);
                }}
              >
                <TbTrashXFilled color="black" size="1.9em" />
              </Button>
            </Group>
          </Group>
        )}
      </Card>
      <Modal
        opened={modalOpened}
        onClose={close}
        centered
        withCloseButton={false}
        size="lg"
      >
        <WorkerModal
          closeModal={() => {
            close();
          }}
          startId={selectedWorker}
        ></WorkerModal>
      </Modal>
    </Card>
  );
};
